<script setup lang="ts">
import { ChevronUpIcon } from "@heroicons/vue/24/outline";

type PropsType = {
  title: string;
  content: string;
};

const props = defineProps<PropsType>();

const title = toRef(() => props.title);
const content = toRef(() => props.content);

const isShow = ref(false);

function toggleIsShow() {
  isShow.value = !isShow.value;
}
</script>

<template>
  <div class="collapsible">
    <div class="title" @click="toggleIsShow()">
      <p>{{ title }}</p>

      <div
        class="transition-all duration-150"
        :class="{ 'rotate-180': !isShow }"
      >
        <ChevronUpIcon class="w-[20px]" />
      </div>
    </div>

    <Transition name="fade" mode="out-in">
      <div v-if="isShow" class="content">
        <BaseRichText :content="content" />
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.collapsible {
  .title {
    @apply bg-secondary/30 px-5 py-3 text-sm flex
    items-center justify-between cursor-pointer;

    // p {}
  }

  .content {
    @apply px-5 py-3 border text-sm;

    :deep() {
      ul {
        li {
          @apply text-primary;

          a {
            @apply text-sm;
          }
        }
      }
    }
  }
}
</style>
